import {
  useMutation,
  UseMutationResult,
  useQuery,
  UseQueryResult,
} from "@tanstack/react-query";
import { AxiosError } from "axios";
import { API } from "../../utils/API/API";

export type ProfilUpdateBody = {
  name?: string;
  picture?: string;
  userPreferences?: string;
  contentPreferences?: Record<string, boolean>;
};

export const useProfile = (): UseQueryResult<
  IApiResponse<IUser>,
  AxiosError
> => {
  return useQuery({
    queryKey: ["profile", "me"],
    queryFn: () => API.profile(),
  });
};

export const useSubscription = (): UseQueryResult<
  { subscription: Subscription; plan: Plan },
  AxiosError
> => {
  return useQuery({
    queryKey: ["subscription"],
    queryFn: () => API.fetchSubscription(),
  });
};

export const useUpdateProfile = (): UseMutationResult<
  IApiResponse<{ user: IUser; message: string }>,
  AxiosError<{ message: string }>,
  ProfilUpdateBody,
  unknown
> => {
  return useMutation({
    mutationFn: (body: ProfilUpdateBody) => API.updateProfile(body),
  });
};

export const useCancelSubscription = (): UseMutationResult<
  IApiResponse<{ message: string }>,
  AxiosError<{ message: string }>,
  unknown
> => {
  return useMutation({
    mutationFn: () => API.cancelSubsription(),
  });
};
